import { render } from "./ModalRenameRessource.vue?vue&type=template&id=8547b32a&scoped=true&ts=true"
import script from "./ModalRenameRessource.vue?vue&type=script&lang=ts"
export * from "./ModalRenameRessource.vue?vue&type=script&lang=ts"

import "./ModalRenameRessource.vue?vue&type=style&index=0&id=8547b32a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8547b32a"]])

export default __exports__